import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import LoginForm from './LoginForm'
import SetNewPasswordForm from './SetNewPasswordForm'
import ChooseLoginType from './ChooseLoginType'

type Props = {
    loginOptions: null | ObjectStringKeyAnyValue

}


function Login({
    loginOptions
}: Props) {

    const {

    } = useContext(GlobalContext)



    const [authChallenge, setAuthChallenge] = useState<ObjectStringKeyAnyValue | null>(null)



    return <div className={`w-full flex flex-col gap-4`}>

        {authChallenge ?
            <SetNewPasswordForm
                authChallenge={authChallenge}
                setAuthChallenge={setAuthChallenge}
            /> 
            :
            <ChooseLoginType
                loginOptions={loginOptions}
                authChallenge={authChallenge}
                setAuthChallenge={setAuthChallenge}
             />
        }



    </div>
}
export default Login